export default "__VITE_ASSET__70526539__"